module.exports = __webpack_public_path__ + "img/facebook-icon.0a46e245.svg";